import React from "react";
import { renderRoutes } from "react-router-config";
import { Redirect } from "react-router-dom";
import MainComponent from "./main";
import Layout from "@/app/core/layouts/main";
import Storage from "@/app/core/util/Storage";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";

const userData = Storage.getUserData();

const ProjectShell = (props) =>
    Storage.isAuthenticated() && userData && userData.level === UserHelper.UserLevel.Administrator ? (
        <Layout {...props}>{renderRoutes(props.route.routes, props)}</Layout>
    ) : (
        <Redirect to="/" />
    );

const Redirecter = () => <Redirect to="/error/404" />;

const UsersRouter = {
    path: "/users",
    component: ProjectShell,
    routes: [
        {
            path: "/users",
            exact: true,
            component: MainComponent,
        },
        {
            path: "*",
            component: Redirecter,
        },
    ],
};

export default UsersRouter;